import { ComponentPropsWithoutRef, FC } from 'react';

export type PlusIconProps = ComponentPropsWithoutRef<'svg'>;

export const PlusIcon: FC<PlusIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="-3 -3 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M4.54248 5.44712H0.584957V4.53208H4.54248V0.574554H5.45752V4.53208H9.41504V5.44712H5.45752V9.40464H4.54248V5.44712Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
